<div class="sole-trader-component">
  <div class="row">
    <div class="col-12">
      <div class="application-subsection-title">Sole Trader</div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <individual-form
        [mark]="markObservable"
        [showAddressForm]="showAddressForm"
        [showIdentification]="showIdentification"
        [formControl]="formControlIndividual">
      </individual-form>
    </div>
  </div>
</div>
